// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/warning.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rework-wrapper .p-dialog-header, .changeHandling-wrapper .p-dialog-header {
  padding: 0;
}

.selectionpopup .deselectedtasks {
  padding-bottom: 20px;
}
.selectionpopup .selectedtasks,
.selectionpopup .deselectedtasks {
  max-height: 20rem;
  overflow: auto;
  margin-bottom: 20px;
}
.selectionpopup .selectedtasks table,
.selectionpopup .deselectedtasks table {
  width: 100%;
  border: 0.5px solid #acacac;
}
.selectionpopup .selectedtasks table tr th,
.selectionpopup .deselectedtasks table tr th {
  border: 0.5px solid #acacac;
  background-color: #edf4fa;
  color: #003da5;
  height: 32px;
  padding-left: 20px;
}
.selectionpopup .selectedtasks table tr td,
.selectionpopup .deselectedtasks table tr td {
  border: 0.5px solid #acacac;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.63px;
  text-align: left;
  padding: 5px;
  word-break: break-all;
}
.selectionpopup .selectedtasks th:nth-child(1),
.selectionpopup .selectedtasks td:nth-child(1),
.selectionpopup .deselectedtasks th:nth-child(1),
.selectionpopup .deselectedtasks td:nth-child(1) {
  width: 15%;
  min-width: 120px;
}
.selectionpopup .preHead {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: #595959;
  display: inline-block;
  margin-bottom: 8px;
}
.selectionpopup .p-dialog {
  width: 50%;
}
.selectionpopup .headers {
  position: relative;
}
.selectionpopup .headers .headerText {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: left;
  color: #003da5;
  font-family: "Montserrat";
}
.selectionpopup .headers .infoText {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #d37302;
}
.selectionpopup .headers .infoText .textVal {
  padding-left: 30px;
  display: inline-block;
}
.selectionpopup .infoText::before {
  width: 24px;
  position: absolute;
  left: 0;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.selectionpopup .footerbutton {
  position: relative;
}
.selectionpopup .footerbutton footer {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  position: absolute;
  bottom: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopUp/index.scss"],"names":[],"mappings":"AAIE;EACE,UAAA;AAHJ;;AASE;EACE,oBAAA;AANJ;AAUE;;EAEE,iBAAA;EACA,cAAA;EACA,mBAAA;AARJ;AAUI;;EACE,WAAA;EACA,2BAAA;AAPN;AAUQ;;EACE,2BAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAPV;AAUQ;;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AAPV;AAYE;;;;EAIE,UAAA;EACA,gBAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AAXJ;AAcE;EACE,UAAA;AAZJ;AAeE;EACE,kBAAA;AAbJ;AAeI;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAbN;AAgBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAdN;AAgBM;EACE,kBAAA;EACA,qBAAA;AAdR;AAmBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,gDAAA;AAjBJ;AAmBE;EACE,kBAAA;AAjBJ;AAmBE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAjBJ","sourcesContent":["$primary: #003da5;\n$secondary: #acacac;\n\n.rework-wrapper,.changeHandling-wrapper {\n  .p-dialog-header {\n    padding: 0;\n  }\n}\n\n.selectionpopup {\n\n  .deselectedtasks {\n    padding-bottom: 20px;\n  }\n\n\n  .selectedtasks,\n  .deselectedtasks {\n    max-height: 20rem;\n    overflow: auto;\n    margin-bottom: 20px;\n\n    table {\n      width: 100%;\n      border: 0.5px solid #acacac;\n\n      tr {\n        th {\n          border: 0.5px solid #acacac;\n          background-color: #edf4fa;\n          color: #003da5;\n          height: 32px;\n          padding-left: 20px;\n        }\n\n        td {\n          border: 0.5px solid #acacac;\n          font-size: 12px;\n          font-weight: 400;\n          line-height: 14.63px;\n          text-align: left;\n          padding: 5px;\n          word-break: break-all;\n        }\n      }\n    }\n  }\n  .selectedtasks th:nth-child(1),\n  .selectedtasks td:nth-child(1),\n  .deselectedtasks th:nth-child(1),\n  .deselectedtasks td:nth-child(1) {\n    width: 15%;\n    min-width: 120px;\n  }\n\n  .preHead {\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    color: #595959;\n    display: inline-block;\n    margin-bottom: 8px;\n  }\n\n  .p-dialog {\n    width: 50%;\n  }\n\n  .headers {\n    position: relative;\n\n    .headerText {\n      font-size: 1.5rem;\n      font-weight: 500;\n      text-align: left;\n      color: #003da5;\n      font-family: \"Montserrat\";\n    }\n\n    .infoText {\n      font-size: 14px;\n      font-weight: 500;\n      text-align: left;\n      color: #d37302;\n\n      .textVal {\n        padding-left: 30px;\n        display: inline-block;\n      }\n    }\n  }\n\n  .infoText::before {\n    width: 24px;\n    position: absolute;\n    left: 0;\n    content: url(\"../../assets/images/warning.svg\");\n  }\n  .footerbutton{\n    position: relative;\n  }\n  .footerbutton footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 2rem;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
